import React, { useState } from 'react';
import { postQuestion } from './ApiService';

const ChatComponent = () => {
  const [userInput, setUserInput] = useState('');
  const [response, setResponse] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const resp = await postQuestion(userInput);
      setResponse(resp.response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={userInput}
          onChange={e => setUserInput(e.target.value)}
          placeholder="Votre message ici"
          style={{ width: '30%'}}
        />
        <button type="submit">envoyer</button>
      </form>
      {response && <p>{response}</p>}
    </div>
  );
};

export default ChatComponent;


